module.exports = __webpack_public_path__ + "static/media/PM35.91d7bd9d.JPG";